<template>

  <div>
    <div class="messages" v-show="showBox" key="messages" v-loading="loading">
      <div class="titolo col-24 no-padding">
        {{ $t('messages.messaggi').toUpperCase() }}
        &emsp;

        <icon class="pointer" name="riv-reload" scale="1" @click.native="getMessaggi"></icon>

      </div>

      <el-tabs v-model="activeTab" class="tabs-class custom-tabs" :style="{ height: height + 'px' }">
        <el-tab-pane name="nuovi" :key="($t('messages.nuovi') + ' ' + counterNonLetti)">
          <div slot="label">
            <div class="col-24 no-padding counter-nuovi">
              <el-badge :value="counterNonLetti" class="item" :hidden="(counterNonLetti <= 0)">
                {{ $t('messages.nuovi') }}
              </el-badge>
            </div>
            <div class="col-24 no-padding barra"></div>
          </div>

          <div v-for="(messaggio, index) in messaggiNonLetti" class="messaggio" :key="index">
            <div class="testata col-24">
              <div class="titolo">
                {{ messaggio.titolo.toUpperCase() }}
              </div>
              <div class="priorita" v-if="(messaggio.priorita === '1')">
                <icon name="riv-preferitiFull" scale="0.8"></icon>
              </div>
              <div class="allegati" v-if="(messaggio.allegati.length > 0)">
                <icon name="riv-attach" scale="1"></icon>
              </div>
            </div>
            <div class="col-24 testo" v-html="truncateCard(messaggio.testo)"></div>
            <div class="footer col-24">
              <div class="data">
                {{ $t('messages')[new Date(messaggio.data.substr(0, 4), parseInt(messaggio.data.substr(5, 2)) - 1, messaggio.data.substr(8, 2)).getDay()] + ', ' + moment(messaggio.data, 'YYYY-MM-DD-HH.mm').format('DD/MM/YYYY HH:mm') }}
              </div>
              <el-button class="custom-button" type="primary" @click="openMessageModal(true, messaggio)">{{ $t('messages.leggi') }}</el-button>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="letti" :key="($t('messages.letti') + ' ' + counterLetti)">
          <div slot="label">
            <div class="col-24 no-padding">
              {{ $t('messages.letti') + ((counterLetti > 0) ? (' (' + counterLetti + ')') : '') }}
            </div>
            <div class="col-24 no-padding barra"></div>
          </div>

          <div v-for="(messaggio, index) in messaggiLetti" class="messaggio" :key="index">
            <div class="testata col-24">
              <div class="titolo">
                {{ messaggio.titolo.toUpperCase() }}
              </div>
              <div class="priorita" v-if="(messaggio.priorita === '1')">
                <icon name="riv-preferitiFull" scale="0.8"></icon>
              </div>
              <div class="allegati" v-if="(messaggio.allegati.length > 0)">
                <icon name="riv-attach" scale="1"></icon>
              </div>
            </div>
            <div class="col-24 testo" v-html="truncateCard(messaggio.testo)"></div>
            <div class="footer col-24">
              <div class="data">
                {{ $t('messages')[new Date(messaggio.data.substr(0, 4), parseInt(messaggio.data.substr(5, 2)) - 1, messaggio.data.substr(8, 2)).getDay()] + ', ' + moment(messaggio.data, 'YYYY-MM-DD-HH.mm').format('DD/MM/YYYY HH:mm') }}
              </div>
              <el-button class="custom-button" type="primary" @click="openMessageModal(false, messaggio)">{{ $t('messages.leggi') }}</el-button>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="bacheca" :key="($t('messages.bacheca') + ' ' + counterBacheca)">
          <div slot="label">
            <div class="col-24 no-padding counter-bacheca">
              <el-badge :value="counterBacheca" class="item" :hidden="(counterBacheca <= 0)">
                {{ $t('messages.bacheca') }}
              </el-badge>
            </div>
            <div class="col-24 no-padding barra"></div>
          </div>

          <div v-for="(messaggio, index) in messaggiBacheca" class="messaggio" :key="index">
            <div class="testata col-24">
              <div class="titolo">
                {{ messaggio.titolo.toUpperCase() }}
              </div>
              <!--
              <div class="ricevuto">
                {{ $t('messages.ricevuto') + ' ' + moment(messaggio.data, 'YYYY-MM-DD-HH.mm').format('DD/MM/YYYY') }}
              </div>
              -->
              <div class="allegati" v-if="(messaggio.allegati.length > 0)">
                <icon name="riv-attach" scale="1"></icon>
              </div>
            </div>
            <div class="col-24 testo" v-html="truncateCard(messaggio.testo)"></div>
            <div class="footer col-24">
              <div class="data">
                {{ $t('messages.scade') + ' ' + moment(messaggio.dataA, 'YYYY-MM-DD').format('DD/MM/YYYY') }}
              </div>
              <el-button class="custom-button" type="primary" @click="openMessageModal(false, messaggio)">{{ $t('messages.leggi') }}</el-button>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <el-dialog class="modal-message" :visible.sync="messageDialogVisible" @close="getMessaggi"
               width="600px" :append-to-body="true" 
               :title="msg.titolo.toUpperCase()" custom-class="custom-dialog">

      <div class="col-24 no-padding data">
        {{ $t('messages')[new Date(msg.data.substr(0, 4), parseInt(msg.data.substr(5, 2)) - 1, msg.data.substr(8, 2)).getDay()] + ', ' + moment(msg.data, 'YYYY-MM-DD-HH.mm').format('DD/MM/YYYY HH:mm') }}
      </div>
      <div class="priorita col-24 no-padding" v-if="(msg.priorita === '1' && !msg.hasOwnProperty('dataA'))">
        <span class="prior-label">
          {{ $t('messages.priorita.label') + ': ' }}
        </span>
        <span class="prior-value">
          {{ $t('messages.priorita')[msg.priorita].toUpperCase() }}
        </span>
        <span class="prior-icon">
          <icon name="riv-preferitiFull" scale="0.8"></icon>
        </span>
      </div>
      <div class="testo col-24 no-padding" v-html="msg.testo"></div>
      <div class="allegati col-24 no-padding" v-if="(msg.allegati.length > 0)">
        <div v-for="mess in msg.allegati" :key="mess.keyDoc">
          <div class="col-24 no-padding allegato" @click="getAllegato(mess)">
            <icon class="icona" name="riv-attach" scale="1"></icon>
            <div class="titolo-allegato">
              {{ mess.titolo }}
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="footer">
        <div class="col-24 no-padding">
          <div class="scade" v-if="(msg.hasOwnProperty('dataA'))">
            {{ $t('messages.scade') + ' ' + moment(msg.dataA, 'YYYY-MM-DD').format('DD/MM/YYYY') }}
          </div>
          <el-button class="custom-button" type="primary" v-if="(!msg.hasOwnProperty('dataA'))" @click="setMessaggioService(msg, 'C')">
            {{ $t('messages.elimina').toUpperCase() }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog class="modalMessaggi" @close="closeMessages"
               custom-class="custom-dialog offset-xl-5 col-xl-14 offset-lg-4 col-lg-16 offset-md-2 col-md-20 offset-0 col-24"
               :append-to-body="true" key="dialog"
               :visible.sync="showModal">

      <span slot="title">
        {{ $t('messages.messaggi').toUpperCase() }}
        &emsp;

        <icon class="pointer" name="riv-reload" scale="1" @click.native="getMessaggi"></icon>

      </span>

      <div v-loading="loading">
        <el-tabs v-model="activeTab" class="custom-tabs tabs-class" @tab-click="changeTab">
          <el-tab-pane name="nuovi" :key="($t('messages.nuovi') + ' ' + counterNonLetti)">
            <div slot="label">
              <div class="col-24 no-padding counter-nuovi">
                <el-badge :value="counterNonLetti" class="item" :hidden="(counterNonLetti <= 0)">
                  {{ $t('messages.nuovi') }}
                </el-badge>
              </div>
              <div class="col-24 no-padding barra"></div>
            </div>

            <div class="row row-custom">
              <div class="col-8 no-padding elenco-messaggi">
                <el-card class="col-24" v-for="(item, index) in messaggiNonLetti"
                         :key="index"
                         :class="{ selected: (messaggio.id === item.id && messaggio.codForn === item.codForn && messaggio.country === item.country) }">
                  <div class="testata col-24">
                    <div class="titolo">
                      {{ item.titolo.toUpperCase() }}
                    </div>
                    <div class="priorita" v-if="(item.priorita === '1')">
                      <icon name="riv-preferitiFull" scale="0.8"></icon>
                    </div>
                    <div class="allegati" v-if="(item.allegati.length > 0)">
                      <icon name="riv-attach" scale="1"></icon>
                    </div>
                  </div>
                  <div class="col-24 testo" v-html="truncateCardModal(item.testo)"></div>
                  <div class="footer col-24 no-padding">
                    <div class="data">
                      {{ $t('messages')[new Date(item.data.substr(0, 4), parseInt(item.data.substr(5, 2)) - 1, item.data.substr(8, 2)).getDay()] + ', ' + moment(item.data, 'YYYY-MM-DD-HH.mm').format('DD/MM/YYYY HH:mm') }}
                    </div>
                    <el-button @click="setMessaggio(true, item)" class="custom-button" type="primary">
                      {{ $t('messages.leggi') }}
                    </el-button>
                  </div>
                </el-card>
              </div>
              <div class="col-16 area-messaggio">
                <div class="col-24 msg" v-if="showMessaggio">
                  <div class="titolo col-24 no-padding">
                    {{ messaggio.titolo }}
                  </div>
                  <div class="data col-24 no-padding">
                    {{ (messaggio.data !== '') ? ($t('messages')[new Date(messaggio.data.substr(0, 4), parseInt(messaggio.data.substr(5, 2)) - 1, messaggio.data.substr(8, 2)).getDay()] + ', ' + moment(messaggio.data, 'YYYY-MM-DD-HH.mm').format('DD/MM/YYYY HH:mm')) : '' }}
                  </div>
                  <div class="priorita col-24 no-padding" v-if="(messaggio.priorita === '1')">
                    <span class="prior-label">
                      {{ $t('messages.priorita.label') + ': ' }}
                    </span>
                    <span class="prior-value">
                      {{ $t('messages.priorita')[messaggio.priorita].toUpperCase() }}
                    </span>
                    <span class="prior-icon">
                      <icon name="riv-preferitiFull" scale="0.8"></icon>
                    </span>
                  </div>
                  <div class="testo col-24 no-padding" v-html="messaggio.testo"></div>
                  <div class="allegati col-24 no-padding" v-if="(messaggio.allegati.length > 0)">
                    <div v-for="msg in messaggio.allegati" :key="msg.keyDoc">
                      <div class="col-24 no-padding allegato" @click="getAllegato(msg)">
                        <icon class="icona" name="riv-attach" scale="1"></icon>
                        <div class="titolo-allegato">
                          {{ msg.titolo }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="messaggio-footer col-24 no-padding" v-if="(messaggio.id !== undefined)">
                    <el-button @click="setMessaggioService(messaggio, 'C')" class="custom-button" type="primary">
                      {{ $t('messages.elimina').toUpperCase() }}
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane name="letti" :key="($t('messages.letti') + ' ' + counterLetti)">
            <div slot="label">
              <div class="col-24 no-padding">
                {{ $t('messages.letti') + ((counterLetti > 0) ? (' (' + counterLetti + ')') : '') }}
              </div>
              <div class="col-24 no-padding barra"></div>
            </div>

            <div class="row row-custom">
              <div class="col-8 no-padding elenco-messaggi">
                <el-card class="col-24" v-for="(item, index) in messaggiLetti"
                         :key="index"
                         :class="{ selected: (messaggio.id === item.id && messaggio.codForn === item.codForn && messaggio.country === item.country) }">
                  <div class="testata col-24">
                    <div class="titolo">
                      {{ item.titolo.toUpperCase() }}
                    </div>
                    <div class="priorita" v-if="(item.priorita === '1')">
                      <icon name="riv-preferitiFull" scale="0.8"></icon>
                    </div>
                    <div class="allegati" v-if="(item.allegati.length > 0)">
                      <icon name="riv-attach" scale="1"></icon>
                    </div>
                  </div>
                  <div class="col-24 testo" v-html="truncateCardModal(item.testo)"></div>
                  <div class="footer col-24 no-padding">
                    <div class="data">
                      {{ $t('messages')[new Date(item.data.substr(0, 4), parseInt(item.data.substr(5, 2)) - 1, item.data.substr(8, 2)).getDay()] + ', ' + moment(item.data, 'YYYY-MM-DD-HH.mm').format('DD/MM/YYYY HH:mm') }}
                    </div>
                    <el-button @click="setMessaggio(false, item)" class="custom-button" type="primary">
                      {{ $t('messages.leggi') }}
                    </el-button>
                  </div>
                </el-card>
              </div>
              <div class="col-16 area-messaggio">
                <div class="col-24 msg" v-if="showMessaggio">
                  <div class="titolo col-24 no-padding">
                    {{ messaggio.titolo }}
                  </div>
                  <div class="data col-24 no-padding">
                    {{ (messaggio.data !== '') ? ($t('messages')[new Date(messaggio.data.substr(0, 4), parseInt(messaggio.data.substr(5, 2)) - 1, messaggio.data.substr(8, 2)).getDay()] + ', ' + moment(messaggio.data, 'YYYY-MM-DD-HH.mm').format('DD/MM/YYYY HH:mm')) : '' }}
                  </div>
                  <div class="priorita col-24 no-padding" v-if="(messaggio.priorita === '1')">
                    <span class="prior-label">
                      {{ $t('messages.priorita.label') + ': ' }}
                    </span>
                    <span class="prior-value">
                      {{ $t('messages.priorita')[messaggio.priorita].toUpperCase() }}
                    </span>
                    <span class="prior-icon">
                      <icon name="riv-preferitiFull" scale="0.8"></icon>
                    </span>
                  </div>
                  <div class="testo col-24 no-padding" v-html="messaggio.testo"></div>
                  <div class="allegati col-24 no-padding" v-if="(messaggio.allegati.length > 0)">
                    <div v-for="msg in messaggio.allegati" :key="msg.keyDoc">
                      <div class="col-24 no-padding allegato" @click="getAllegato(msg)">
                        <icon class="icona" name="riv-attach" scale="1"></icon>
                        <div class="titolo-allegato">
                          {{ msg.titolo }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="messaggio-footer col-24 no-padding" v-if="(messaggio.id !== undefined)">
                    <el-button @click="setMessaggioService(messaggio, 'C')" class="custom-button" type="primary">
                      {{ $t('messages.elimina').toUpperCase() }}
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane name="bacheca" :key="($t('messages.bacheca') + ' ' + counterBacheca)">
            <div slot="label">
              <div class="col-24 no-padding counter-bacheca">
                <el-badge :value="counterBacheca" class="item" :hidden="(counterBacheca <= 0)">
                  {{ $t('messages.bacheca') }}
                </el-badge>
              </div>
              <div class="col-24 no-padding barra"></div>
            </div>

            <div class="row row-custom">
              <div class="col-8 no-padding elenco-messaggi">
                <el-card class="col-24" v-for="(item, index) in messaggiBacheca"
                         :key="index"
                         :class="{ selected: (messaggio.id === item.id && messaggio.codForn === item.codForn && messaggio.country === item.country) }">
                  <div class="testata col-24">
                    <div class="titolo">
                      {{ item.titolo.toUpperCase() }}
                    </div>
                    <!--
                    <div class="ricevuto">
                      {{ moment(item.data, 'YYYY-MM-DD-HH.mm').format('DD/MM/YYYY') }}
                    </div>
                    -->
                    <div class="allegati" v-if="(item.allegati.length > 0)">
                      <icon name="riv-attach" scale="1"></icon>
                    </div>
                  </div>
                  <div class="col-24 testo" v-html="truncateCardModal(item.testo)"></div>
                  <div class="footer col-24 no-padding">
                    <div class="data">
                      {{ $t('messages.scade') + ' ' + moment(item.dataA, 'YYYY-MM-DD').format('DD/MM/YYYY') }}
                    </div>
                    <el-button @click="setMessaggio(false, item)" class="custom-button" type="primary">
                      {{ $t('messages.leggi') }}
                    </el-button>
                  </div>
                </el-card>
              </div>
              <div class="col-16 area-messaggio">
                <div class="col-24 msg" v-if="showMessaggio">
                  <div class="titolo col-24 no-padding">
                    {{ messaggio.titolo }}
                  </div>
                  <div class="data col-24 no-padding">
                    {{ $t('messages')[new Date(messaggio.data.substr(0, 4), parseInt(messaggio.data.substr(5, 2)) - 1, messaggio.data.substr(8, 2)).getDay()] + ', ' + moment(messaggio.data, 'YYYY-MM-DD-HH.mm').format('DD/MM/YYYY HH:mm') }}
                  </div>
                  <div class="testo col-24 no-padding" v-html="messaggio.testo"></div>
                  <div class="allegati col-24 no-padding" v-if="(messaggio.allegati.length > 0)">
                    <div v-for="msg in messaggio.allegati" :key="msg.keyDoc">
                      <div class="col-24 no-padding allegato" @click="getAllegato(msg)">
                        <icon class="icona" name="riv-attach" scale="1"></icon>
                        <div class="titolo-allegato">
                          {{ msg.titolo }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
  </div>

</template>

<script>
  import moment from 'moment'
  import { bus } from './Bus'

  export default {
    name: 'Messages',
    props: {
      height: {
        type: Number,
        required: true,
        default: 550
      },
      showMessages: {
        type: Object,
        required: true,
        default: function () {
          let obj = {
            val: false,
            type: 1
          }
          return obj
        }
      }
    },
    i18n: {
      messages: {
        it_IT: {
          messages: {
            nuovi: 'Nuovi',
            letti: 'Letti',
            bacheca: 'Bacheca',
            messaggi: 'Messaggi',
            noMsg: 'Nessun messaggio',
            1: 'Lunedì',
            2: 'Martedì',
            3: 'Mercoledì',
            4: 'Giovedì',
            5: 'Venerdì',
            6: 'Sabato',
            0: 'Domenica',
            leggi: 'Leggi',
            priorita: {
              label: 'Priorità',
              1: 'Alta'
            },
            elimina: 'Elimina',
            scade: 'Scade il',
            ricevuto: 'Ricevuto il'
          }
        },
        fr_FR: {
          messages: {
            nuovi: 'Nouveau',
            letti: 'Lu',
            bacheca: 'Petites Ann.',
            messaggi: 'Messages',
            noMsg: 'Pas de message',
            1: 'Lundi',
            2: 'Mardi',
            3: 'Mercredi',
            4: 'Jeudi',
            5: 'Vendredi',
            6: 'Sabbat',
            0: 'Dimanche',
            leggi: 'Lire',
            priorita: {
              label: 'Priorité',
              1: 'Haute'
            },
            elimina: 'Éliminer',
            scade: 'Expire le',
            ricevuto: 'Reçu le'
          }
        },
        es_ES: {
          messages: {
            nuovi: 'Nuevos',
            letti: 'Leidos',
            bacheca: 'Prioritari',
            messaggi: 'Mensajes',
            noMsg: 'Sin mensaje',
            1: 'Lunes',
            2: 'Martes',
            3: 'Miércoles',
            4: 'Jueves',
            5: 'Viernes',
            6: 'Sábado',
            0: 'Domingo',
            leggi: 'Leer',
            priorita: {
              label: 'Prioridad',
              1: 'Alto'
            },
            elimina: 'Eliminar',
            scade: 'Vence el',
            ricevuto: 'Recibido el'
          }
        },
        de_DE: {
          messages: {
            nuovi: 'Neu',
            letti: 'Gelesen',
            bacheca: 'Schwarzes Brett',
            messaggi: 'Beiträge',
            noMsg: 'Keine nachricht',
            1: 'Montag',
            2: 'Dienstag',
            3: 'Mittwoch',
            4: 'Donnerstag',
            5: 'Freitag',
            6: 'Sabbat',
            0: 'Sonntag',
            leggi: 'Lesen',
            priorita: {
              label: 'Priorität',
              1: 'Hoch'
            },
            elimina: 'Beseitigen',
            scade: 'Läuft am ab',
            ricevuto: 'Eingegangen am'
          }
        },
        en_GB: {
          messages: {
            nuovi: 'New',
            letti: 'Read',
            bacheca: 'Notice Board',
            messaggi: 'Messages',
            noMsg: 'No messages',
            1: 'Monday',
            2: 'Tuesday',
            3: 'Wednesday',
            4: 'Thursday',
            5: 'Friday',
            6: 'Saturday',
            0: 'Sunday',
            leggi: 'Read',
            priorita: {
              label: 'Priority',
              1: 'High'
            },
            elimina: 'Remove',
            scade: 'Expires',
            ricevuto: 'Received on'
          }
        }
      }
    },
    data () {
      return {
        moment: moment,
        loading: true,
        activeTab: 'nuovi',
        msg: {
          titolo: '',
          data: '',
          testo: '',
          allegati: []
        },
        messaggio: {},
        showMessaggio: false,
        messageDialogVisible: false,
        messaggiLetti: [],
        messaggiBacheca: [],
        messaggiNonLetti: [],
        counterLetti: 0,
        counterBacheca: 0,
        counterNonLetti: 0,
        codLang: (sessionStorage.hasOwnProperty('codLang')) ? (sessionStorage.getItem('codLang')) : 'it_IT'
      }
    },
    filters: {
      truncateCard: function (text) {
        if (text.length > 100) {
          return text.substr(0, 100) + '...'
        } else {
          return text
        }
      },
      truncateCardModal: function (text) {
        if (text.length > 50) {
          return text.substr(0, 50) + '...'
        } else {
          return text
        }
      }
    },
    computed: {
      showModal: {
        get: function () {
          return (this.showMessages.val && this.showMessages.type === 1)
        },
        set: function (newValue) {
          //
        }
      },
      showBox: function () {
        return (this.showMessages.val && this.showMessages.type === 0)
      }
    },
    mounted: function () {
      this.getMessaggi()
      this.loading = false
      bus.$on('Header_SetCodFornAdmin', () => {
        this.getMessaggi()
      })
    },
    methods: {
      truncateCard: function (text) {
        if (text.length > 100) {
          return text.substr(0, 100) + '...'
        } else {
          return text
        }
      },
      truncateCardModal: function (text) {
        if (text.length > 50) {
          return text.substr(0, 50) + '...'
        } else {
          return text
        }
      },
      getAllegato: function (msg) {
        this.$http.get('portale/tokendoc')
          .then(response => {
            if (response.body.wsToken) {
              let url = (process.env.baseUrlSpringPortale + 'print/allegato?idCli='
                      + msg.idCli + '&idApp=' + msg.idApp + '&keyDoc=' + msg.keyDoc + '&token=' + response.body.wsToken)
              let win = window.open(url, '_blank')
              win.focus()
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      getMessaggi: function () {
        this.$set(this, 'loading', true)
        setTimeout(() => {
          let msg = {
            titolo: '',
            data: '',
            testo: '',
            allegati: []
          }
          this.$set(this, 'messaggio', msg)
          this.$set(this, 'msg', msg)
          let arrayAdmin = []
          if (localStorage.hasOwnProperty('amministrazione')) {
            let array = JSON.parse(localStorage.getItem('amministrazione'))
            for (let key in array) {
              let area = array[key]
              for (let country in area) {
                if (area[country] !== '') {
                  let obj = {}
                  if (key === 'TRAACQ') {
                    obj = {
                      country: country,
                      codForn: area[country].substring(1)
                    }
                  } else {
                    obj = {
                      country: country,
                      codForn: area[country]
                    }
                  }
                  arrayAdmin.push(obj)
                }
              }
            }
          }
          this.$http.get('portale/messaggi', {
            params: {
              admin: JSON.stringify(arrayAdmin),
              codLang: this.codLang
            }
          })
            .then(response => {
              if (response.body.rc === 0) {
                this.$set(this, 'messaggiNonLetti', response.body.data.nonLetti)
                this.$set(this, 'messaggiLetti', response.body.data.letti)
                this.$set(this, 'messaggiBacheca', response.body.data.bacheca)
                this.$set(this, 'counterNonLetti', parseInt(response.body.attrib.nonLetti))
                this.$set(this, 'counterLetti', parseInt(response.body.attrib.letti))
                this.$set(this, 'counterBacheca', parseInt(response.body.attrib.bacheca))
                this.$emit('changeCounterNuovi', parseInt(response.body.attrib.nonLetti))
                this.$emit('changeCounterBacheca', parseInt(response.body.attrib.bacheca))
              } else {
                this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'error',
                  duration: process.env.duration
                })
              }
              this.$set(this, 'loading', false)
            })
        }, 200)
      },
      setMessaggioService: function (messaggio, operazione) {
        let data = {
          id: messaggio.id,
          codForn: messaggio.codForn,
          country: messaggio.country,
          op: operazione
        }
        this.$http.post('portale/messaggio', data, {
          params: {
            codLang: this.codLang
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              if (operazione === 'C') {
                this.$set(this, 'messageDialogVisible', false)
                this.getMessaggi()
              }
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      changeTab: function () {
        this.$set(this, 'showMessaggio', false)
        this.$set(this, 'messaggio', {})
      },
      closeMessages: function () {
        this.$set(this, 'showMessaggio', false)
        this.$set(this, 'messaggio', {})
        this.$emit('closeMessages')
        this.getMessaggi()
      },
      setMessaggio: function (ifNonLetto, msg) {
        this.$set(this, 'messaggio', msg)
        this.$set(this, 'showMessaggio', true)
        if (ifNonLetto === true) {
          this.setMessaggioService(msg, 'L')
        }
      },
      formatDate: function (date) {
        return date.substr(6, 2) + '/' + date.substr(4, 2) + '/' + date.substr(0, 4)
      },
      truncate: function (text) {
        if (text.length > 135) {
          return text.substr(0, 135) + '...'
        } else {
          return text
        }
      },
      openMessageModal: function (ifNonLetto, msg) {
        this.$set(this, 'messageDialogVisible', true)
        this.$set(this, 'msg', msg)
        if (ifNonLetto === true) {
          this.setMessaggioService(msg, 'L')
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../assets/less/general.less";

  .modalMessaggi {
    &.el-dialog__wrapper {
      .el-dialog {
        .el-dialog__header {
          border-bottom: 0;
          letter-spacing: 2px;
          .set-font(@size: 14px, @family: 'os-semibold', @color: @greenRiva);
        }
        .el-dialog__body {
          .el-tabs {
            .el-tabs__header {
              .el-tabs__nav-wrap {
                border-bottom: 0;
              }
              .el-tabs__item {
                width: 33.33%;
                .barra {
                  height: 4px;
                }
                .counter-nuovi {
                  .el-badge {
                    .el-badge__content {
                      height: 18px;
                      width: 18px;
                      top: 9px;
                      right: -3px;
                      padding: 0;
                      line-height: 16px;
                      .set-font(@color: @white, @size: 10px);
                      letter-spacing: 0;
                      background-color: red;
                    }
                  }
                }
                .counter-bacheca {
                  .el-badge {
                    .el-badge__content {
                      height: 18px;
                      width: 18px;
                      top: 9px;
                      right: -3px;
                      padding: 0;
                      line-height: 16px;
                      .set-font(@color: @white, @size: 10px);
                      letter-spacing: 0;
                      background-color: @oroRiva;
                    }
                  }
                }
              }
            }
            .el-tabs__content {
              .el-tab-pane {
                overflow: auto;
                .elenco-messaggi {
                  height: 460px;
                  overflow: auto;
                  padding-right: 5px !important;
                  .el-card {
                    height: 115px;
                    float: left;
                    margin-bottom: 10px;
                    border-radius: 0px;
                    padding: 5px 10px !important;
                    .el-card__body {
                      padding: 0;
                      height: 100%;
                      .testata {
                        width: 100%;
                        height: 30px;
                        padding: 0 !important;
                        display: flex;
                        justify-content: space-between;
                        .titolo {
                          width: 70%;
                          .set-font(@family: 'os-semibold', @color: @greenRiva, @size: 14px);
                          text-align: left;
                          white-space: nowrap;
                          overflow: hidden;
                          text-overflow: ellipsis;
                        }
                        .priorita {
                          margin-left: 10px;
                          .fa-icon {
                            color: red;
                          }
                        }
                        .allegati {
                          .fa-icon {
                            color: @greenRiva;
                          }
                        }
                        .ricevuto {
                          .set-font(@color: @greenRiva, @size: 10px);
                          font-style: italic;
                          margin-top: 3px;
                        }
                      }
                      .testo {
                        padding: 0 5px !important;
                        .set-font(@size: 12px; @color: @textTable);
                        text-align: left;
                      }
                      .footer {
                        display: inline-block;
                        position: absolute;
                        bottom: 6px;
                        left: 0;
                        padding: 0 10px !important;
                        .data {
                          .set-font(@size: 10px);
                          float: left;
                          line-height: 20px;
                          font-style: italic;
                          padding-top: 2px;
                        }
                        .el-button {
                          float: right;
                          height: 23px;
                          line-height: 20px;
                          padding: 0 6px;
                          border-color: @oroRiva !important;
                          background-color: @oroRiva !important;
                        }
                      }
                    }
                  }
                }
                .area-messaggio {
                  min-height: 480px;
                  padding-left: 20px;
                  padding: 0 10px 0 0 !important;
                  .msg {
                    height: 100%;
                    border-left: 1px solid #e7e7e7;
                    padding: 0 0 0 20px !important;
                    .titolo {
                      .set-font(@color: @greenRiva, @size: 16px, @family: 'os-semibold');
                      text-align: left;
                      line-height: 20px;
                    }
                    .data {
                      .set-font(@color: @textTable, @size: 12px);
                      margin-top: 15px;
                      text-align: right;
                      font-style: italic;
                    }
                    .priorita {
                      margin-top: 15px;
                      text-align: left;
                      .prior-label {
                        .set-font(@color: @textTable, @size: 14px, @family: 'os-semibold');
                      }
                      .prior-value {
                        margin-left: 2px;
                        .set-font(@color: red, @size: 14px, @family: 'os-semibold');
                      }
                      .prior-icon {
                        .fa-icon {
                          color: red;
                          margin-top: -4px;
                          margin-left: 2px;
                        }
                      }
                    }
                    .testo {
                      margin-top: 20px;
                      .set-font(@color: @textTable, @size: 13px);
                      text-align: justify;
                      height: 230px;
                      overflow: auto;
                      padding-right: 5px !important;
                    }
                    .allegati {
                      margin-top: 10px;
                      min-height: 60px;
                      max-height: 110px;
                      overflow: auto;
                      padding-right: 5px !important;
                      .allegato {
                        display: inline-block;
                        .icona {
                          width: 10%;
                          float: left;
                          padding-top: 2px;
                        }
                        .titolo-allegato {
                          width: 85%;
                          float: left;
                          .set-font(@color: @greenRiva, @size: 13px);
                          text-align: left;
                          white-space: nowrap;
                          overflow: hidden;
                          text-overflow: ellipsis;
                        }
                      }
                      .allegato:hover {
                        cursor: pointer;
                      }
                    }
                    .messaggio-footer {
                      position: absolute;
                      bottom: 0;
                      left: 0;
                      height: 35px;
                      .el-button {
                        float: right;
                        height: 30px;
                        line-height: 25px;
                        padding: 0 6px;
                      }
                    }
                  }
                }
              }
              .no-msg {
                margin-top: 20px;
              }
              .box-card:hover {
                cursor: pointer;
              }
              .selected {
                background-color: @hoverTbl;
              }
            }
          }
        }
      }
    }
  }

  .modal-message {
    .el-dialog {
      .el-dialog__body {
        .data {
          width: 100%;
          text-align: right;
          margin-top: 10px;
          .set-font(@size: 12px, @color: @textTable);
          font-style: italic;
          padding: 0 4px !important;
        }
        .priorita {
          margin-top: 15px;
          text-align: left;
          .prior-label {
            .set-font(@color: @textTable, @size: 14px, @family: 'os-semibold');
          }
          .prior-value {
            margin-left: 2px;
            .set-font(@color: red, @size: 14px, @family: 'os-semibold');
          }
          .prior-icon {
            .fa-icon {
              color: red;
              margin-top: -4px;
              margin-left: 2px;
            }
          }
        }
        .testo {
          margin-top: 20px;
          .set-font(@color: @textTable, @size: 13px);
          text-align: justify;
          height: auto;
          overflow: auto;
          padding-right: 5px !important;
        }
        .allegati {
          min-height: 30px;
          max-height: 120px;
          overflow: auto;
          margin-top: 30px;
          margin-bottom: 20px;
          .allegato {
            display: inline-block;
            .icona {
              width: 10%;
              float: left;
              padding-top: 2px;
            }
            .titolo-allegato {
              width: 85%;
              float: left;
              .set-font(@color: @greenRiva, @size: 13px);
              text-align: left;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
          .allegato:hover {
            cursor: pointer;
          }
        }
      }
      .el-dialog__footer {
        padding: 10px 0 0;
        .footer {
          height: 45px;
          width: 100%;
          padding: 0 !important;
          .scade {
            padding: 10px 0 0 15px;
            .set-font(@color: @textTable, @size: 12px);
            font-style: italic;
          }
        }
      }
    }
  }

  .messages {
    position: absolute;
    top: 76px;
    right: 0px;
    width: 400px;
    .set-font(@size: 14px);
    .titolo {
      height: 30px;
      text-align: center;
      vertical-align: bottom;
      line-height: 30px;
      .set-font(@color: @greenRiva, @family: 'os-semibold', @size: 16px);
      z-index: 10;
    }
    .tabs-class {
      overflow: auto;
    }
    .el-tabs {
      margin-top: 35px;
      .el-tabs__header {
        margin-bottom: 10px;
        height: 30px;
        position: absolute;
        right: 0px;
        top: 30px;
        width: 100%;
        z-index: 10;
        .el-tabs__nav-wrap {
          border-bottom: 0;
        }
        .el-tabs__nav {
          width: 100%;
          height: 35px;
          background-color: #eef4f9;
          .el-tabs__item {
            width: 33.333%;
            background-color: #eef4f9;
            .barra {
              height: 2px;
            }
            .counter-nuovi {
              .el-badge {
                .el-badge__content {
                  height: 20px;
                  width: 20px;
                  top: 9px;
                  right: -3px;
                  padding: 0;
                  line-height: 16px;
                  .set-font(@color: @white, @size: 10px);
                  letter-spacing: 0;
                  background-color: red;
                }
              }
            }
            .counter-bacheca {
              .el-badge {
                .el-badge__content {
                  height: 20px;
                  width: 20px;
                  top: 9px;
                  right: -3px;
                  padding: 0;
                  line-height: 16px;
                  .set-font(@color: @white, @size: 10px);
                  letter-spacing: 0;
                  background-color: @oroRiva;
                }
              }
            }
          }
        }
      }
      .el-tabs__content {
        overflow: auto;
        .messaggio {
          box-shadow: 1px 1px 12px 1px rgba(0, 0, 0, 0.2);
          transition: 0.3s;
          border-radius: 0;
          width: 97%;
          height: 120px;
          background-color: @white;
          margin: auto;
          margin-bottom: 5px;
          margin-top: 10px;
          .testata {
            width: 100%;
            height: 30px;
            padding: 0 15px;
            display: flex;
            justify-content: space-between;
            .titolo {
              width: 65%;
              .set-font(@family: 'os-semibold', @color: @greenRiva, @size: 14px);
              text-align: left;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .priorita {
              margin-top: 2px;
              margin-left: 10px;
              .fa-icon {
                color: red;
              }
            }
            .allegati {
              margin-top: 3px;
              .fa-icon {
                color: @greenRiva;
              }
            }
            .ricevuto {
              .set-font(@color: @greenRiva, @size: 11px);
              font-style: italic;
              margin-top: 6px;
            }
          }
          .testo {
            padding: 6px 20px;
            .set-font(@color: @textTable, @size: 12px);
            line-height: 16px;
            height: 60px;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .footer {
            width: 100%;
            height: 30px;
            padding: 0 15px;
            display: flex;
            justify-content: space-between;
            .data {
              .set-font(@color: @greenRiva, @size: 11px);
              font-style: italic;
              height: 20px;
              line-height: 20px;
            }
            .el-button {
              height: 23px;
              line-height: 20px;
              padding: 0 7px;
              background-color: @oroRiva !important;
              border-color: @oroRiva !important;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Messages.vue